__turbopack_context__.v({
  "blok-big-title": "HeroCardBlok-module__KKc32a__blok-big-title",
  "blok-subtitle": "HeroCardBlok-module__KKc32a__blok-subtitle",
  "blok-title": "HeroCardBlok-module__KKc32a__blok-title",
  "image": "HeroCardBlok-module__KKc32a__image",
  "root": "HeroCardBlok-module__KKc32a__root",
  "subtitle": "HeroCardBlok-module__KKc32a__subtitle",
  "tag": "HeroCardBlok-module__KKc32a__tag",
  "tag__wrapper": "HeroCardBlok-module__KKc32a__tag__wrapper",
  "title": "HeroCardBlok-module__KKc32a__title",
});
